import React from 'react';
import { useTranslation } from 'react-i18next';
import CustomTabComponent from 'components/CustomTab';
import {Grid} from '@material-ui/core'
import { useStyles } from './styles';
import StudentCertificates from '../ProfileCertificate/index';
import StudentCertificatesOffline from '../ProfileCertificate/CertificateAttendance'

const CertificatesForStudent = () => {
  const classes = useStyles();
    const [paginationNumber, setPaginationNumber] = React.useState(0);
    const [open, setOpen] = React.useState(false);
    
   const { t } = useTranslation([
      'title',
      'form',
      'button',
      'validation',
      'toastify',
      'label',
    ]);

  const tabComponents = [
      {
        label: t('button:User.btn_profile_courses_cert'),
        component: <StudentCertificates  />
      },
      {
        label: t('button:User.btn_profile_courses_not_online_cert'),
        component: <StudentCertificatesOffline />
      }, 
    ];

  return (
    <div className={classes.root}>
      <div className={classes.topButtonContainer}>
        <Grid item xs={12}>
          <CustomTabComponent
            components={tabComponents}
            valueReturn={(value) => setPaginationNumber(value)}
          />
        </Grid>
      </div>
    </div>
    );
};

export default CertificatesForStudent;
